import { FC } from 'react';

import { PublisherCardLayoutContainerProps } from 'shared/components/PublisherCardLayout/types';

import styles from './PublisherCardLayoutCompact.css';

type PublisherCardLayoutCompactProps = Pick<PublisherCardLayoutContainerProps, 'avatar' | 'type' | 'nameWithBadges'> & {
  shouldDisplayAvatar: boolean;
};

export const PublisherCardLayoutCompact: FC<PublisherCardLayoutCompactProps> = props => {
  const { avatar, type, nameWithBadges, shouldDisplayAvatar } = props;

  return (
    <>
      {shouldDisplayAvatar && <div className={styles['avatar-wrapper']}>{avatar}</div>}
      <div className={styles['type-name-container']}>
        <div className={styles['type']}>{type}</div>
        {nameWithBadges}
      </div>
    </>
  );
};
